import moment from 'moment'
import { TCMDepartureConsultationField } from '../NoteFormsConstants'
import { useSelector } from 'react-redux'
import targetIcon from '../../../../assets/images/target.svg'


export const ViewTCMDepartureConsultation = ({content, guestName, conductedBy})=>{
    const consultationNotesData = useSelector(state => state.consultationNotesReducer)

    return (
        <div className="my-3 ">
            <div className="rounded border d-flex justify-content-between bg-light p-2 mb-2">
                <div className='d-flex'>
                    <div className="fw-semi-bold mr-2 flex-shrink-0  me-3" >Conducted By:</div>
                    <div className="text-break white-space">{conductedBy || '-'}</div>
                </div>
                <div className='d-flex  w-25'>
                    <div className="fw-semi-bold mr-2 flex-shrink-0  me-3" >Date:</div>
                    <div className="text-break white-space">{content.date? moment(content.date).format('DD MMM, YYYY') : '-'}</div>
                </div>
            </div>
            <div className=" w-100 rounded my-4">
                <div className="fw-semi-bold">
                    Dear {guestName},
                </div>
                Congratulations on successfully completing your wellness programme. To sustain the results of your programme, it is essential to adhere to the recommendations outlined in the debrief consultation document for a minimum duration of 3 months. For any clarifications during this period, consult Ananda’s Ayurvedic Physician during post-stay online follow-ups.  
            </div>
            <div className='border rounded overflow-hidden'>
                <div className="bg-light text-center py-2 text-brown border-bottom fw-semibold">
                PROGRAMME & TREATMENT PLAN
                </div>
                <div className='p-3'>
                <div className='fw-semibold mb-3 text-uppercase  text-secondary'>Primary objectives for improvement: <span className="fw-normal text-dark">{content?.data?.summary_assessment_treatment_plan?.objectives?.length ? '' : <>&nbsp; -</>} </span> </div>

                    {
                        content?.data?.programme_and_treatment_plan?.objectives?.map((item, index)=>{
                                return (
                                    <div className={index===0 ? '': ' mt-4 '} key={index}>
                                        <div className='border bg-light fw-semibold text-secondary p-2 text-uppercase'>                                             
                                            <img src={targetIcon} className='me-2' width={'20px'} alt="" />{(index+1)?.toString()?.padStart(2, 0)}
                                        </div>
                                        <table className='p-2 w-100'>
                                            <tbody>
                                            {
                                                TCMDepartureConsultationField?.objectives?.map((item, subIndex)=>(
                                                    <tr className='d-flex' key={subIndex}>
                                                        <td className="fw-semi-bold border p-2 mr-2 flex-shrink-0" style={{width: '230px'}}>{item?.label}</td>
                                                        <td className="text-break border flex-grow-1 p-2 white-space">{content.data?.programme_and_treatment_plan?.objectives?.[index]?.[item.key] || '-'}</td>
                                                    </tr>
                                                    ))
                                            }
                                            </tbody>
                                        </table>
                                    </div>
                                )
                            })
                        }
                        
                </div>
            </div>
            <div className='border rounded my-4 overflow-hidden'>
                <div className="bg-light text-center py-2 text-brown border-bottom fw-semibold">
                    HEALTH ASSESSMENT
                </div>
                <div className="row m-0 fw-semibold" >
                    <div className="p-2 border col-3">Parameter</div>
                    <div className='p-2 border col-4'>
                        On Arrival
                    </div>
                    <div className='p-2 border col-5'>
                        On Departure
                    </div>
                </div>
                    {
                        TCMDepartureConsultationField?.healthAssessment?.map((item, index)=>{
                            return (
                                <div className="row m-0" key={index}>
                                    <div className=" border border-bottom-0 p-2 col-3 fw-semi-bold text-secondary ">{item.label}</div>
                                    <div className='border border-bottom-0 p-2 col-4'>
                                        {content?.data?.health_assessment?.[item.key]?.arrival_reading || '-'}
                                    </div>
                                    <div className='border border-bottom-0 p-2 col-5'>
                                        {content?.data?.health_assessment?.[item.key]?.value || '-'}
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            <div className='border rounded my-4 overflow-hidden'>
                <div className="bg-light text-center py-2 text-brown border-bottom fw-semibold">
                RECOMMENDATIONS AND FOLLOW UPS
                </div>
                <div className=''>
                    <div className="row m-0 fw-semibold" >
                    <div className="p-2 border col-2">Recommendation</div>
                    <div className="p-2 border col-4">Details</div>
                        <div className='p-2 border col-2'>
                        Time of practice
                        </div>
                        <div className="p-2 border col-2">Duration/Repetition</div>

                        <div className='p-2 border col-2'>
                            Frequency
                        </div>
                    </div>
                        {
                            content.data.recommendations_and_follow_ups?.map((item, index)=>{
                                return (
                                    <div className="row w-100 m-0" key={index}>
                                        <div className=" border border-bottom-0 p-2 col-2">{item.recommendation || '-'}</div>
                                        <div className=" border border-bottom-0 p-2 col-4">{item.details || '-'}</div>
                                        <div className=" border border-bottom-0 p-2 col-2">{item.time || '-'}</div>
                                        <div className='col-2 border border-bottom-0 p-2 '>
                                            {item?.duration|| '-'}
                                        </div>
                                        <div className='col-2 border border-bottom-0 p-2 '>
                                            <div className="data-input">
                                                {item?.frequency || '-'}
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
            </div>

            <div className="border rounded my-3 overflow-hidden">
                <div className="bg-light text-brown text-center py-2 fw-semibold">
                FOLLOW UP PROGRAMME
                </div>
                <div className=' '>
                    <div className='d-flex'>
                        <div className="fw-semi-bold border p-2 flex-shrink-0" style={{width: '230px'}}>Follow up Consultation:</div>
                        <div className="text-break flex-grow-1 border p-2 white-space">{content?.data?.follow_up_programme?.consultation || '-'}</div>
                    </div>
                    <div className='d-flex'>
                        <div className="fw-semi-bold border p-2 flex-shrink-0" style={{width: '230px'}}>Follow up Visit (Programme):</div>
                        <div className="text-break flex-grow-1 border p-2 white-space">{content?.data?.follow_up_programme?.programme || '-'}</div>
                    </div>
                    <div className='d-flex'>
                        <div className="fw-semi-bold border p-2 flex-shrink-0" style={{width: '230px'}}>Follow up Visit (Timeline):</div>
                        <div className="text-break flex-grow-1 border p-2 white-space">{content?.data?.follow_up_programme?.timeline || '-'}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}
